import api from './index';
//
let exports = {};

exports.getGoodsWrntExtVoucherList = function (data, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/paged/list/get')
        .data(data)
        .done(callback)
        .go();
};

exports.goodsWrntExtVoucherSave = function (data, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/save/do')
        .data(data)
        .done(callback)
        .go();
};

exports.goodsWrntExtVoucherUpdate = function (data, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/update/do')
        .data(data)
        .done(callback)
        .go();
};

exports.deleteGoodsWrntExtVoucher = function (postData, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/delete/do')
        .data(postData)
        .done(callback)
        .go();
};

exports.getGoodsWrntExtVoucher = function (postData, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/veiw/do')
        .data(postData)
        .done(callback)
        .go();
};

exports.applyGoodsWrntExtVoucher = function (postData, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/apply/do')
        .data(postData)
        .done(callback)
        .go();
};

exports.auditGoodsWrntExtVoucher = function (postData, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/audit/do')
        .data(postData)
        .done(callback)
        .go();
};

exports.confirmGoodsWrntExtVoucher = function (postData, callback) {
    api.post('/goodsWrnt/goods/wrnt/ext/voucher/confirm/do')
        .data(postData)
        .done(callback)
        .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/goodsWrnt.js
// module id = 350
// module chunks = 0